import {
  ICustomerContentCode,
  ICustomerVideo,
  ITestimonialBlockquote
} from "types/interfaces/customers/ICustomer";
import { PortableText } from "@portabletext/react";
import { sanityImgBuilder } from "../../sanity";
import {
  ContentBlockQuote,
  ContentCode,
  ContentH1,
  ContentH2,
  ContentH3,
  ContentH4,
  ContentImage,
  ContentImageWrapper,
  ContentInlineCode,
  ContentLink,
  ContentNormal,
  ContentOrderedList,
  Testimonial,
  TestimonialBlockQuote,
  TestimonialName,
  TestimonialPosition,
  ContentUnorderdList
} from "./styles";

interface IProps {
  content: any[];
}

const ArticleContent = ({ content }: IProps) => {
  return (
    <PortableText
      value={content}
      components={{
        block: {
          h1: ({ children }) => <ContentH1>{children}</ContentH1>,
          h2: ({ children }) => <ContentH2>{children}</ContentH2>,
          h3: ({ children }) => <ContentH3>{children}</ContentH3>,
          h4: ({ children }) => <ContentH4>{children}</ContentH4>,
          normal: ({ children }) => <ContentNormal>{children}</ContentNormal>,
          blockquote: ({ children }) => <ContentBlockQuote>{children}</ContentBlockQuote>
        },
        list: {
          bullet: ({ children }) => <ContentUnorderdList>{children}</ContentUnorderdList>,
          number: ({ children }) => <ContentOrderedList>{children}</ContentOrderedList>
        },
        types: {
          image: ({ value }) => (
            <ContentImageWrapper>
              <ContentImage src={sanityImgBuilder.image(value).url()} alt="content-image" />
            </ContentImageWrapper>
          ),
          video: ({ value }) => {
            const { url, caption, altText } = value as ICustomerVideo;
            return <iframe height={"300"} width={"600"} src={url}></iframe>;
          },
          code: ({ value }) => {
            const { code, language } = value as ICustomerContentCode;
            return (
              <ContentCode
                language={`language-${language === "sh" ? "bash" : language}`}
                content={`\n${code.trim()}`}
                enableCopy={true}
              />
            );
          },
          testimonialBlockquote: ({ value }) => {
            const { testimonial, name, position } = value as ITestimonialBlockquote;
            return (
              <TestimonialBlockQuote>
                <Testimonial>{testimonial}</Testimonial>
                <TestimonialName>{name}</TestimonialName>
                <TestimonialPosition>{position}</TestimonialPosition>
              </TestimonialBlockQuote>
            );
          }
        },
        marks: {
          link: ({ children, value }) => <ContentLink href={value.href}>{children}</ContentLink>,
          code: ({ text }) => <ContentInlineCode>{text}</ContentInlineCode>
        }
      }}
    />
  );
};

export default ArticleContent;
